<template>
  <rd-container size="large">
    <rd-header
      :title="$t('index.title', { totalCount: getDepartmentsTotalCount })"
    >
      <dx-button
        :use-submit-behavior="false"
        type="default"
        :text="$t('buttons.add')"
        @click="showAddPopup"
      >
      </dx-button>
    </rd-header>
    <div class="row">
      <rd-column :size="$columns.TwelveOnLg">
        <!-- Grid -->
        <dx-data-grid
          :data-source="getDepartmentsList"
          :remote-operations="true"
          :allow-column-resizing="true"
          :column-auto-width="false"
          :control-column-resizing="false"
          :repaint-changes-only="true"
          :allow-column-reordering="true"
          :row-alternation-enabled="true"
          :hover-state-enabled="true"
          class="main-datagrid"
          ref="gridData"
        >
          <dx-filter-row
            :visible="true"
            apply-filter="auto"
            :show-operation-chooser="false"
          />
          <dx-column
            data-field="CompanyId"
            :caption="$t('index.captions.company')"
            data-type="string"
          >
            <dx-lookup
              :search-enabled="true"
              :data-source="getCompaniesDataSource"
              display-expr="Text"
              value-expr="Value"
              :closeOnOutsideClick="true"
            >
            </dx-lookup>
          </dx-column>
          <dx-column
            data-field="DepartmentName"
            :caption="$t('index.captions.departmentName')"
            data-type="string"
          />
          <dx-column
            data-field="Shortcut"
            :caption="$t('index.captions.shortcut')"
            data-type="string"
          />
          <dx-column
            data-field="FvShortcut"
            :caption="$t('index.captions.fvShortcut')"
            data-type="string"
          />
          <dx-column
            data-field="WorkerGroupId"
            :caption="$t('index.captions.workerGroup')"
            data-type="string"
          >
            <dx-lookup
              :search-enabled="true"
              :data-source="getRolesDataSource"
              display-expr="Text"
              value-expr="Value"
              :closeOnOutsideClick="true"
            >
            </dx-lookup>
          </dx-column>
          <dx-column
            data-field="SupervisorGroupId"
            :caption="$t('index.captions.supervisorGroup')"
            data-type="string"
          >
            <dx-lookup
              :search-enabled="true"
              :data-source="getRolesDataSource"
              display-expr="Text"
              value-expr="Value"
              :closeOnOutsideClick="true"
            >
            </dx-lookup>
          </dx-column>
          <dx-column
            data-field="ManagerGroupId"
            :caption="$t('index.captions.managerGroup')"
            data-type="string"
          >
            <dx-lookup
              :search-enabled="true"
              :data-source="getRolesDataSource"
              display-expr="Text"
              value-expr="Value"
              :closeOnOutsideClick="true"
            >
            </dx-lookup>
          </dx-column>
          <dx-column
            data-field="ManagementGroupId"
            :caption="$t('index.captions.managementGroup')"
            data-type="string"
          >
            <dx-lookup
              :search-enabled="true"
              :data-source="getRolesDataSource"
              display-expr="Text"
              value-expr="Value"
              :closeOnOutsideClick="true"
            >
            </dx-lookup>
          </dx-column>
          <dx-column
            data-field="FkAccount"
            :caption="$t('index.captions.fkAccount')"
            data-type="string"
          />
          <dx-column
            data-field="FkOwnCost"
            :caption="$t('index.captions.fkOwnCost')"
            data-type="string"
          />
          <dx-column
            data-field="Id"
            :allow-filtering="false"
            :allow-reordering="false"
            :allow-resizing="false"
            alignment="center"
            :width="175"
            :caption="$t('index.captions.actions')"
            cell-template="cellTemplate"
          />
          <dx-pager
            :allowed-page-sizes="pageSizes"
            :show-page-size-selector="true"
          />
          <dx-paging :page-size="30" />
          <div slot="cellTemplate" slot-scope="{ data }">
            <!--<router-link :to="{name: 'dictionaries.departments.details', params: {id: data.value}}">
                            <dx-button styling-mode="text" :hint="$t('buttons.details')" :title="$t('buttons.details')" icon="fas fa-list" type="normal" class="datagrid-button" />
                        </router-link>-->

            <span
              :hint="$t('buttons.edit')"
              :title="$t('buttons.edit')"
              class="main-datagrid-btn"
              @click="showEditPopup(data)"
              ><i class="fas fa-pen"></i
            ></span>
            <span
              :hint="$t('buttons.delete')"
              :title="$t('buttons.delete')"
              class="main-datagrid-btn"
              @click="showDeletePopup(data)"
              ><i class="fas fa-trash"></i
            ></span>
          </div>
          <dx-paging :page-size="30" />
          <template #nameHyperlink="{ data }">
            <span
              :hint="$t('buttons.edit')"
              :title="$t('buttons.edit')"
              style="color: #4099ff; text-decoration: underline;"
              @click="showEditPopup(data)"
              >{{ data.data.Department }}</span
            >
          </template>
        </dx-data-grid>

        <!-- Delete -->
        <rd-popup
          :visibility="popupOptions.popupVisible"
          :title="$t('popup.title.deleteDepartment')"
        >
          <rd-popup-content>
            <ul>
              <li
                v-for="(item, index) in popupOptions.fields"
                v-bind:key="index"
              >
                <label>{{ item.name }}: </label> {{ item.value }}
              </li>
            </ul>
          </rd-popup-content>
          <rd-popup-actions>
            <dx-button
              :type="cancelBtnOption.type"
              styling-mode="text"
              :text="cancelBtnOption.text"
              @click="function() {
                  popupOptions.popupVisible = false;
                }
              "
            />
            <dx-button
              :type="deleteBtnOption.type"
              class="ml-1"
              :text="deleteBtnOption.text"
              @click="deleteDepartmentPopup(popupOptions.id)"
            />
          </rd-popup-actions>
        </rd-popup>

        <!-- Add -->

        <rd-popup
          :visibility="addPopupOptions.popupVisible"
          :title="$t('add.title')"
          size="large"
        >
          <addForm @closeAdd="onAddPopupClose"></addForm>
        </rd-popup>

        <!-- Edit -->
        <rd-popup
          :visibility="editPopupOptions.popupVisible"
          :title="$t('edit.title')"
          size="large"
        >
          <editForm @closeEdit="onEditPopupClose"></editForm>
        </rd-popup>
      </rd-column>
    </div>
  </rd-container>
</template>
<script>
// @ is an alias to /src
import {
  DxDataGrid,
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxLookup
} from 'devextreme-vue/data-grid';
import DxButton from 'devextreme-vue/button';

import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";
import commonMessages from "../../locales";
import localMessages from "../locales";
import addForm from "./Add";
import editForm from "./Edit";

const name =
  "administrationStores/dictionariesStores/departmentsStores/indexStore";
const edit =
  "administrationStores/dictionariesStores/departmentsStores/editStore";

export default {
  name: "appDepartmentsList",
  created() {
    this.setRolesDataSource();
    this.setCompaniesDataSource();
  },
  data() {
    return {
      popupOptions: {
        popupVisible: false,
        id: null,
        fields: [
          {
            name: this.$t("index.captions.company"),
            value: "",
          },
          {
            name: this.$t("index.captions.departmentName"),
            value: "",
          },
          {
            name: this.$t("index.captions.shortcut"),
            value: "",
          },
          {
            name: this.$t("index.captions.fvShortcut"),
            value: "",
          },
          {
            name: this.$t("index.captions.workerGroup"),
            value: "",
          },
          {
            name: this.$t("index.captions.supervisorGroup"),
            value: "",
          },
          {
            name: this.$t("index.captions.managerGroup"),
            value: "",
          },
          {
            name: this.$t("index.captions.managementGroup"),
            value: "",
          },
          {
            name: this.$t("index.captions.fkAccount"),
            value: "",
          },
          {
            name: this.$t("index.captions.fkOwnCost"),
            value: "",
          },
        ],
      },
      cancelBtnOption: {
        type: "normal",
        text: this.$t("buttons.cancel"),
      },
      deleteBtnOption: {
        type: "danger",
        text: this.$t("buttons.delete"),
      },
      addBtnOptions: {
        type: "default",
        text: this.$t("buttons.add"),
      },
      addPopupOptions: {
        popupVisible: false,
      },
      editPopupOptions: {
        popupVisible: false,
      },
      pageSizes: [30, 50, 100],
    };
  },
  computed: {
    ...mapGetters(name, [
      "getDepartmentsList",
      "getDepartmentsTotalCount",
      "getRolesDataSource",
      "getCompaniesDataSource",
    ]),
    ...mapFields(name, []),
  },
  methods: {
    ...mapActions(name, [
      "setDepartmentsList",
      "setLoaded",
      "setDepartmentsTotalCount",
      "deleteDepartment",
      "setToken",
      "setRolesDataSource",
      "setCompaniesDataSource",
    ]),
    ...mapActions(edit, ["setEditDetails"]),
    showDeletePopup(options) {
      this.popupOptions.fields[0].value = options.data.CompanyId;
      this.popupOptions.fields[1].value = options.data.departmentName;
      this.popupOptions.fields[2].value = options.data.Shortcut;
      this.popupOptions.fields[3].value = options.data.FvShortcut;
      this.popupOptions.fields[4].value = options.data.WorkerGroupId;
      this.popupOptions.fields[5].value = options.data.SupervisorGroupId;
      this.popupOptions.fields[6].value = options.data.ManagerGroupId;
      this.popupOptions.fields[7].value = options.data.ManagementGroupId;
      this.popupOptions.fields[8].value = options.data.FkAccount;
      this.popupOptions.fields[9].value = options.data.FkOwnCost;

      this.popupOptions.id = options.data.Id;
      this.popupOptions.popupVisible = true;
    },
    deleteDepartmentPopup(recordId) {
      this.deleteDepartment(recordId);
      this.popupOptions.popupVisible = false;
    },
    showAddPopup() {
      this.addPopupOptions.popupVisible = true;
    },
    showEditPopup(options) {
      this.setEditDetails(options.data.Id);
      this.editPopupOptions.popupVisible = true;
    },
    onAddPopupClose() {
      this.addPopupOptions.popupVisible = false;
    },
    onEditPopupClose() {
      this.editPopupOptions.popupVisible = false;
    },
  },
  mounted() {
    var gridInstance = this.$refs.gridData.instance;
    var setDepartmentsTotalCount = this.setDepartmentsTotalCount;
    this.setLoaded(() => {
      this.totalCount = setDepartmentsTotalCount(gridInstance.totalCount());
    });
    this.setDepartmentsList();
    this.setToken();
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxButton,
    DxLookup,
    addForm,
    editForm,
  },
  i18n: {
    messages: localMessages.messages,
    sharedMessages: commonMessages.messages,
  },
};
</script>
<style scoped>
span:hover {
  cursor: pointer;
}
</style>
